import { appLayout } from '#app/init_app_layout.svelte.ts'
import { info } from '#app/lib/loggers'
import { treq } from '#app/lib/treq'
import { commands } from '#app/radio'
import type { ControllersAPI } from '#server/types/controllers_api'

export type FeedbackParams = ControllersAPI['feedback']['post']['default']['params']

export async function postFeedback (params: FeedbackParams) {
  if (params.context == null) params.context = {}
  // @ts-expect-error
  params.context.location = document.location.pathname + document.location.search
  info(params, 'posting feedback')
  return treq('feedback', 'post', 'default', params)
}

type FeedbackModalOptions = Pick<FeedbackParams, 'subject' | 'uris'>

export async function showFeedbackModal (options: FeedbackModalOptions) {
  const { default: FeedbackMenu } = await import('#general/components/feedback_menu.svelte')
  appLayout.showChildComponent('modal', FeedbackMenu, {
    props: {
      standalone: false,
      ...options,
    },
  })
  commands.execute('modal:open')
}
